//@ts-check

// External
import React from "react"
import useStyles from "./enter-eth-address.styles"
import { Check as CheckIcon } from "@material-ui/icons"
import Chip from "@material-ui/core/Chip"
import { useTranslation } from "react-i18next"

// Internal
import { REQUEST_STATES } from "shared/consts"
import Button from "../button"
import { isValidAddress } from "src/utils/is-valid-address"

export default function ConfirmExtractCode({
  inputAddress,
  loadingSolidityState,
  onExtractFromMainnet,
  mainnetRequestState,
}) {
  const classes = useStyles({})
  const { t } = useTranslation()
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {mainnetRequestState == REQUEST_STATES.READY && (
        // the initial state
        <div className={classes.extractCodeButton}>
          <Button
            rounded
            color="primary"
            wrapped
            loading={loadingSolidityState}
            showLoadingInsideButton
            onClick={onExtractFromMainnet}
            className={classes.mainnetAddressSubmit}
            size="small"
          >
            <CheckIcon />
            &nbsp; &nbsp;
            {t("extract_code")}
          </Button>
        </div>
      )}
      <div style={{ paddingTop: "12px" }}>
        {mainnetRequestState == REQUEST_STATES.SUCCESS && (
          <div className={classes.codeExtractedNotice}>
            <Chip type="success" label={t("code_extracted")} />
          </div>
        )}
        {mainnetRequestState == REQUEST_STATES.FAILURE && (
          <div className={classes.codeExtractedNotice}>
            {/*
        // @ts-ignore */}
            <Chip type="error" label={t("failed")} />
          </div>
        )}
      </div>
    </div>
  )
}
